import FlareIcon from '@mui/icons-material/Flare';
import { Card, CardContent, Typography } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';
import { Stack, Theme } from '@mui/system';
import BackNavigationButton from '../../components/common/BackNavigationButton';
import PageContainer from '../../components/common/PageContainter';

const InventoryWelcome = () => {
    const theme: Theme = useTheme();
    return (
        <PageContainer>
            <Typography variant="h5" sx={{ marginBottom: theme.spacing(2) }}>
                <BackNavigationButton /> Content Welcome
            </Typography>
            <Card variant="elevation" sx={{ marginBottom: theme.spacing(2) }}>
                <CardContent>
                    <Typography variant="h6" sx={{ marginBottom: theme.spacing(2) }}>
                        <strong>Overview</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ marginBottom: theme.spacing(4) }}>
                        OnlyStruggles Content Manager is your one stop shop to manage templates, the vault, and more!
                    </Typography>
                    <Typography variant="h6" sx={{ marginBottom: theme.spacing(2) }}>
                        {/* <strong>Automatic List Adding upon Fan purchase</strong> */}
                        <strong>Templates</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ marginBottom: theme.spacing(2) }}>
                        Templates are used throughout the site and allow you to quickly auto-populate forms/fields with everything you need.
                    </Typography>
                    <Stack spacing={1} sx={{ marginBottom: theme.spacing(4) }}>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Autofill</strong> - Send and Exclude Lists, Wall Post Labels, Unlocked and Locked Media, Price, and
                                more!
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Auto List Adding Upon Purchase</strong> - Set a list fans get added to when they purchase ANY media
                                tied to a template. No longer do you have to manually add fans to lists to keep track of who bought what.
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Variations</strong> - Create as many Variations of a template as you'd like! Easy for A/B testing or
                                flowing out your sexting scripts! Use a variation for each portion of the sexting process.
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Content Tags</strong>
                                {` - Add Content Tags (GG, BG, Facial, etc) so you can easily search for the type of content you're looking for!`}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Typography variant="h6" sx={{ marginBottom: theme.spacing(2) }}>
                        <strong>Vault Management</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ marginBottom: theme.spacing(2) }}>
                        This is still a work in progress but here is where you'll be able to manage the vault without ever having to visit
                        OnlyFans itself.
                    </Typography>
                    <Stack spacing={1} sx={{ marginBottom: theme.spacing(2) }}>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Media Titles</strong> - Add a title to any item in your vault so you can quickly identify your
                                content. Also, you can add descriptions and additional notes!
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Upload</strong> - Upload your content directly into your OnlyFans Vault right from the dashboard.
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Download</strong> - View and Download your content
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: '2px' }} />
                            <Typography variant="body1">
                                <strong>Add to Album</strong> - Organise your vault content by adding items to albums right from the
                                dashboard.
                            </Typography>
                        </Stack>
                        {/* <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <FlareIcon color="primary" sx={{ mt: "2px" }} />
                            <Typography variant="body1"><strong>Manage</strong>{` - Create, Edit, and Delete Vault Categories/Albums (Coming soon!)`}</Typography>
                        </Stack> */}
                    </Stack>
                </CardContent>
            </Card>
        </PageContainer>
    );
};

export default InventoryWelcome;
